import React, { useState, useEffect } from 'react';
import { HiX, HiCheckCircle, HiExclamationCircle, HiInformationCircle } from 'react-icons/hi';
import './Notification.css';

const Notification = ({ message, type = 'info', onClose, duration = 10000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          onClose();
        }, 300);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <HiCheckCircle size={20} />;
      case 'error':
        return <HiExclamationCircle size={20} />;
      case 'warning':
        return <HiExclamationCircle size={20} />;
      default:
        return <HiInformationCircle size={20} />;
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`notification notification-${type} ${isVisible ? 'notification-show' : ''}`}>
      <div className="notification-icon">{getIcon()}</div>
      <div className="notification-message">{message}</div>
      <button className="notification-close" onClick={handleClose}>
        <HiX size={18} />
      </button>
    </div>
  );
};

export default Notification;

